import { listDefaults } from '@/utils/urlListState';

/** UniversalFilter keys shared by every handover list tab. */
export const HANDOVER_FILTER_KEYS = [
  'oemIDs',
  'modelIDs',
  'clientIDs',
  'hubIDs',
  'vehicleHubIDs',
  'businessUnits',
] as const;

/**
 * URL defaults for a handover list tab. Only one tab is mounted at a time and
 * switching tabs clears the query, so the tabs can share one set of keys.
 */
export const HANDOVER_LIST_DEFAULTS = listDefaults({
  oemIDs: [] as string[],
  modelIDs: [] as string[],
  clientIDs: [] as string[],
  hubIDs: [] as string[],
  vehicleHubIDs: [] as string[],
  businessUnits: [] as string[],
});
